import { render, staticRenderFns } from "./PreviewPushNotification.vue?vue&type=template&id=8f519d0e&scoped=true&"
import script from "./PreviewPushNotification.vue?vue&type=script&lang=ts&"
export * from "./PreviewPushNotification.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewPushNotification.vue?vue&type=style&index=0&id=8f519d0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f519d0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
